import {NgClass, NgComponentOutlet}                     from '@angular/common';
import {booleanAttribute, Component, inject, input}     from '@angular/core';
import {CrudRecordType, CrudRecordTypes, FirebasePaths} from '@djsharkk/logr-types';
import {DataFactoryService}                             from '../../../../logr-services/data/data-factory.service';
import {PressHoldDirective}                             from '../../../../logr-services/directives/press-hold.directive';
import {SwipeDirective}                                 from '../../../../logr-services/directives/swipe.directive';
import {FirebaseToolsService}                           from '../../../../logr-services/firebase/firebase-tools.service';
import {UiDialogsService}                               from '../../../utils/ui-dialogs.service';
import {TableRowBaseComponent}                          from '../table-row-base/table-row-base.component';
import {TableToolsService}                              from '../table-tools.service';
import {TableLogType, TableRow}                         from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-wrapper',
			   imports    : [
				   SwipeDirective,
				   TableRowBaseComponent,
				   NgComponentOutlet,
				   NgClass,
				   PressHoldDirective
			   ],
			   templateUrl: './table-row-wrapper.component.html',
			   styleUrl   : './table-row-wrapper.component.css'

		   })
export class TableRowWrapperComponent {
	svcDataFactory = inject(DataFactoryService)
	svcFirebaseTools = inject(FirebaseToolsService)
	svcTableTools = inject(TableToolsService)
	svcUiDialogs = inject(UiDialogsService)

	row = input.required<TableRow>();
	hideIcon = input(booleanAttribute(false), {transform: booleanAttribute});
	detailed = input(booleanAttribute(false), {transform: booleanAttribute});

	activeL = false;
	index = false;

	constructor() {

	}

	public swipeL() {
		this.activeL = true;
	}

	public swipeR() {
		this.activeL = false;
	}

	public delete() {
		this.swipeR();
		this.svcFirebaseTools.recDelete(this.row().type as CrudRecordType, this.row().data.id)
	}

	public copy() {
		this.swipeR();
		this.svcFirebaseTools.recAddCopy(this.row().type as CrudRecordType, this.row().data)
	}


	public edit() {
		this.svcUiDialogs.dialogEdit(this.row().type as CrudRecordType, this.row().data).then(confirm => {
			if (confirm) {
				const path: FirebasePaths = `${this.row().type as CrudRecordType}_records_log`
				this.svcFirebaseTools.recUpdate(path, this.row().data.id, this.row().data);
			} else {
				return
			}
		})
	}

	protected readonly CrudRecordTypes = CrudRecordTypes as TableLogType[];
}
